import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const MobileCallButton = () => {
  return (
    <a
      href="tel:+441234567890"
      className="fixed bottom-6 right-6 z-50 md:hidden"
      aria-label="Call us"
    >
      <Button
        size="lg"
        className="rounded-full w-14 h-14 shadow-elevated"
      >
        <Phone className="h-6 w-6" />
      </Button>
    </a>
  );
};

export default MobileCallButton;
